// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3mjQ-","colCheckbox":"styles_colCheckbox__ft3EU"};